/**
 * Parses the filename from Content-Disposition header.
 *
 * @param {string | null} contentDisposition
 * @param {string} fallback
 * @returns {string}
 */
export function parseFilenameFromContentDisposition(
  contentDisposition,
  fallback = 'download'
) {
  if (!contentDisposition) return fallback;

  // RFC 5987 / RFC 6266 filename*=UTF-8''filename.ext
  const filenameStarMatch = contentDisposition.match(
    /filename\*=(?:UTF-8'')?([^;]+)/i
  );
  if (filenameStarMatch && filenameStarMatch[1]) {
    try {
      return decodeURIComponent(
        filenameStarMatch[1].trim().replace(/^['"]|['"]$/g, '')
      );
    } catch {
      return filenameStarMatch[1].trim().replace(/^['"]|['"]$/g, '');
    }
  }

  // Standard filename="filename.ext" or filename=filename.ext
  const filenameMatch = contentDisposition.match(
    /filename=(?:(["'])(.*?)\1|([^;\s]+))/i
  );
  if (filenameMatch) {
    return (filenameMatch[2] || filenameMatch[3] || '').trim();
  }

  return fallback;
}

/**
 * Triggers a browser download for a Blob or { blob: Blob, filename?: string } object.
 *
 * @param {Blob | { blob: Blob, filename?: string } | any} data
 * @param {string} [defaultFilename='download']
 */
export function downloadFile(data, defaultFilename = 'download') {
  if (!data) return;

  let blob = data;
  let filename = defaultFilename;

  if (data && data.blob instanceof Blob) {
    blob = data.blob;
    filename = data.filename || defaultFilename;
  } else if (!(blob instanceof Blob)) {
    blob = new Blob([data]);
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
  }, 100);
}
